export default __webpack_public_path__ + "static/media/CandleScope.0c9fe057d97d12e7e296faa21135807c.webp";